import { HeldEmailQueueDetail } from "./HeldEmailQueueDetail";
import { HeldEmailQueueViewModel } from "./heldEmailQueueViewModel";

export function HeldEmailQueueDetailForView({
  model,
}: {
  model: HeldEmailQueueViewModel;
}) {
  return (
    <HeldEmailQueueDetail
      detailId={model.state.detailId}
      dispatch={model.dispatch}
    />
  );
}
